const ShortDlcProductsIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2173_41128)" />
      <path
        d="M45.6495 22.3471H42.7502V20.4514C42.7502 19.3921 41.8581 18.5 40.7988 18.5C39.7394 18.5 38.8473 19.3921 38.8473 20.4514V22.4029H31.1531V20.4514C31.1531 19.3921 30.261 18.5 29.2017 18.5C28.1423 18.5 27.2502 19.3921 27.2502 20.4514V22.4029H24.3509C22.734 22.3471 21.4517 23.6853 21.4517 25.3022V28.2014H48.5488V25.3022C48.5488 23.6853 47.2664 22.3471 45.6495 22.3471Z"
        fill="white"
      />
      <path
        d="M29.2572 38.3491H29.0342V41.2484H29.2572C29.759 41.2484 30.0935 41.1369 30.3723 40.8581C30.6511 40.5793 30.7626 40.2448 30.7626 39.7988C30.7626 39.3527 30.6511 38.9624 30.3723 38.7394C30.0935 38.4606 29.759 38.3491 29.2572 38.3491Z"
        fill="white"
      />
      <path
        d="M21.4517 30.0972V46.545C21.4517 48.1619 22.734 49.4443 24.3509 49.4443H45.6495C47.2664 49.4443 48.5488 48.1619 48.5488 46.545V30.0972H21.4517ZM31.6549 41.9731C31.0416 42.4749 30.1495 42.7536 29.0344 42.7536H27.306V36.8436H29.0344C30.1495 36.8436 30.9858 37.1223 31.6549 37.6241C32.2682 38.1259 32.6027 38.8508 32.6027 39.7986C32.6027 40.7465 32.2682 41.4713 31.6549 41.9731ZM37.3419 42.7536H33.4948V36.8436H35.2232V41.2482H37.3419V42.7536ZM42.4714 42.5306C41.9696 42.8094 41.4121 42.9767 40.7988 42.9767C39.9067 42.9767 39.1819 42.6979 38.5686 42.0846C37.9553 41.4713 37.6765 40.7464 37.6765 39.8544C37.6765 38.9623 37.9553 38.1817 38.5686 37.6241C39.1819 37.0108 39.9067 36.7321 40.7988 36.7321C41.4121 36.7321 42.0254 36.8993 42.583 37.2339L42.4157 38.9623C41.9139 38.5162 41.3563 38.2932 40.9103 38.2932C40.4643 38.2932 40.1297 38.4605 39.8509 38.7393C39.5722 39.018 39.4607 39.4083 39.4607 39.9101C39.4607 40.4119 39.6279 40.8022 39.9067 41.081C40.1855 41.3598 40.5758 41.527 41.0218 41.527C41.5236 41.527 42.0812 41.304 42.6945 40.8022L42.4714 42.5306Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2173_41128"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8A52CE" />
          <stop offset="1" stop-color="#612BA3" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ShortDlcProductsIconSubcategory
